import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Login() {
  const { user, login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@marketplaceos.com");
  const [password, setPassword] = useState("admin123");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false && user !== null) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-5 bg-[#FCFCFD]">
      {/* Left brand panel */}
      <div className="hidden lg:flex lg:col-span-3 relative overflow-hidden bg-slate-900">
        <img
          src="https://images.unsplash.com/photo-1761044591996-7a05341a3e12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHByZW1pdW0lMjBjb3Jwb3JhdGUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODIxNjkwNHww&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-slate-900/70 to-slate-900/95" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="flex items-center gap-2 text-white">
            <div className="h-9 w-9 rounded-md bg-white/10 backdrop-blur flex items-center justify-center border border-white/20">
              <Sparkles strokeWidth={1.5} className="h-5 w-5" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-base font-bold tracking-tight">Marketplace Intelligence OS</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-white/60">Multi-brand · Amazon · Quick-commerce</span>
            </div>
          </div>
          <div className="text-white max-w-xl">
            <p className="text-[11px] uppercase tracking-[0.25em] text-white/60 mb-4">For marketplace teams</p>
            <h1 className="text-4xl xl:text-5xl font-bold tracking-tight leading-[1.05]">
              Win Marketplace Visibility with <span className="text-emerald-300">Smarter Intelligence</span>.
            </h1>
            <p className="mt-6 text-white/70 text-base leading-relaxed">
              A multi-brand intelligence platform that helps brands understand marketplace demand,
              identify keyword opportunities, monitor competitor movements, improve product positioning,
              and guide teams with execution-ready growth strategies.
            </p>
          </div>
          <div className="text-[11px] text-white/40 tracking-widest">© 2026 Copyright @ Efficienza</div>
        </div>
      </div>

      {/* Right form */}
      <div className="lg:col-span-2 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">Welcome back</h2>
            <p className="mt-2 text-sm text-slate-500">Sign in to your workspace.</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Email
              </Label>
              <Input
                id="email" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="h-11 border-slate-200 bg-white"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Password
              </Label>
              <Input
                id="password" type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="h-11 border-slate-200 bg-white"
              />
            </div>
            {error ? (
              <div data-testid="login-error" className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-700">
                {error}
              </div>
            ) : null}
            <Button
              type="submit"
              data-testid="login-submit"
              disabled={submitting}
              className="w-full h-11 bg-slate-900 text-white hover:bg-slate-800 rounded-lg group"
            >
              {submitting ? "Signing in…" : (
                <span className="inline-flex items-center gap-2">Sign in <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>
              )}
            </Button>
            <div className="rounded-lg border border-dashed border-slate-200 bg-slate-50 p-3 text-[11px] leading-relaxed text-slate-500">
              <span className="font-semibold text-slate-700">Demo accounts</span>
              <div className="mt-1.5 space-y-0.5 font-mono">
                <div>admin@marketplaceos.com / admin123</div>
                <div>manager@marketplaceos.com / manager123</div>
                <div>marketing@marketplaceos.com / marketing123</div>
                <div>viewer@marketplaceos.com / viewer123</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
